"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2005ToJSON = exports.InlineResponse2005FromJSONTyped = exports.InlineResponse2005FromJSON = void 0;
function InlineResponse2005FromJSON(json) {
    return InlineResponse2005FromJSONTyped(json, false);
}
exports.InlineResponse2005FromJSON = InlineResponse2005FromJSON;
function InlineResponse2005FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accountUrl': json['accountUrl'],
    };
}
exports.InlineResponse2005FromJSONTyped = InlineResponse2005FromJSONTyped;
function InlineResponse2005ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accountUrl': value.accountUrl,
    };
}
exports.InlineResponse2005ToJSON = InlineResponse2005ToJSON;
